import { toGlobalId } from 'graphql-relay';

export default function getFieldsFromEnrolments(enrolments) {
  const enrolment = enrolments[0];
  const currentEnrolmentInfo = enrolment.enrolmentInfo[enrolment.enrolmentInfo.length - 1];
  const fields = {
    assignInfo: {
      id: toGlobalId('AssignInfo', enrolment.contentId),
      dueDate: currentEnrolmentInfo.dueDate,
      assignedBy: {
        id: toGlobalId('User', currentEnrolmentInfo.assignerId.toString()),
        pid: currentEnrolmentInfo.assignerId
      },
      assignedDate: currentEnrolmentInfo.assignDate
    },
    user: {
      id: toGlobalId('User', enrolment.userId.toString()),
      pid: enrolment.userId
    }
  };
  return fields;
}
